module.exports = __webpack_public_path__ + "static/media/Logo_MUxDG_Horizontal.6fc7d193.png";